import fetch from "auth/FetchInterceptor";

const VariantService = {};

VariantService.getOptionValues = function (languageId) {
  return fetch({
    url: "/option-values/",
    method: "get",
    headers: {
      "Language-Id": languageId,
    },
  });
};

VariantService.getOptionValue = function (optionValueId, languageId) {
  return fetch({
    url: `/option-values/${optionValueId}/`,
    method: "get",
    headers: {
      "Language-Id": languageId,
    },
  });
};

VariantService.createOptionValue = function (optionValue) {
  return fetch({
    url: "/option-values/",
    method: "post",
    data: optionValue,
  });
};

VariantService.updateOptionValue = function (optionValue) {
  return fetch({
    url: `/option-values/${optionValue.option_value_id}/`,
    method: "put",
    data: optionValue,
  });
};

VariantService.deleteOptionValue = function (optionValueId) {
  return fetch({
    url: `/option-values/${optionValueId}/`,
    method: "delete",
  });
};

export default VariantService;
